// @flow
import * as actions from './actions';
import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';
import handleReduce from '~/core/state/handle-reduce';
import { getOr } from 'lodash/fp';

const EN_GB = 'en-GB';
const IE = 'IE';
const EN_IE = 'en-IE';

const LOCALE_MAPPINGS = {
    [EN_GB + IE]: EN_IE
};

const actionHandlers = new Map([
    // $FlowFixMe
    [actions.attemptLogIn, handleReduce(state => state.set('loggingIn', true))],
    [
        actions.logIn,
        handleReduce((state, action) =>
            // $FlowFixMe
            state.merge({
                locale:
                    LOCALE_MAPPINGS[action.payload.user.locale + action.payload.user.countryCode] ||
                    action.payload.user.locale,
                token: action.payload.token,
                beekeeperEndpoint: getOr(undefined, 'payload.platform.endpoint', action),
                honeycombEndpoint: getOr(undefined, 'payload.platform.honeycomb', action)
            })
        )
    ],
    [
        actions.logInComplete,
        handleReduce(
            state =>
                // $FlowFixMe
                state.withMutations(state =>
                    state
                        .set('loginComplete', true)
                        .set('loggingInError', false)
                        .set('loggingIn', false)
                ),
            // $FlowFixMe
            state => state.withMutations(state => state.set('loggingInError', true).set('loggingIn', false))
        )
    ],
    [
        actions.logInReset,
        handleReduce(state =>
            // $FlowFixMe
            state.withMutations(state => state.set('loggingInError', false).set('loggingIn', false))
        )
    ],
    [
        actions.logOut,
        handleReduce((state, action) =>
            // $FlowFixMe
            state.merge({
                token: undefined,
                beekeeperEndpoint: undefined,
                honeycombEndpoint: undefined,
                loggingOut: true
            })
        )
    ],
    [
        actions.showHiveLiveModal,
        handleReduce((state, { payload: { feature } }) =>
            // $FlowFixMe
            state.set('showHiveLiveModal', feature)
        )
    ],
    // $FlowFixMe
    [actions.hideHiveLiveModal, handleReduce(state => state.set('showHiveLiveModal', false))],
    [
        actions.receiveGTMOffers,
        handleReduce((state, { payload: offers }) =>
            // $FlowFixMe
            state.set('hive-offers', fromJS(offers))
        )
    ],
    [
        actions.showWelcomeMessage,
        handleReduce((state, { payload: welcomeMessage }) =>
            // $FlowFixMe
            state.set('welcomeMessage', fromJS(welcomeMessage)).set('showWelcomeMessage', true)
        )
    ],
    // $FlowFixMe
    [actions.hideWelcomeMessage, handleReduce(state => state.set('showWelcomeMessage', false))],
    // $FlowFixMe
    [actions.showLeakSensorModal, handleReduce(state => state.set('showLeakSensorModal', true))],
    // $FlowFixMe
    [actions.hideLeakSensorModal, handleReduce(state => state.set('showLeakSensorModal', false))],
    // $FlowFixMe
    [actions.showHumidityControl, handleReduce(state => state.set('showHumidityControl', true))],
    // $FlowFixMe
    [actions.hideHumidityControl, handleReduce(state => state.set('showHumidityControl', false))],
    // $FlowFixMe
    [actions.startLoginAnimation, handleReduce(state => state.set('playLoginAnimation', true))],
    // $FlowFixMe
    [actions.stopLoginAnimation, handleReduce(state => state.set('playLoginAnimation', false))]
]);

export default handleActions(
    actionHandlers,
    fromJS({
        loginComplete: false,
        loggingIn: false,
        loggingInError: false,
        showWelcomeMessage: false,
        showHumidityControl: false,
        showLeakSensorModal: false,
        playLoginAnimation: false,
        showServiceOutage: false
    })
);



// WEBPACK FOOTER //
// ./src/core/state/application/index.js